export const LOCATION_PREF_KEY = 'barber_services_location_pref';

/**
 * @returns {{ mode: 'all' } | { mode: 'gps', latitude: number, longitude: number, cityName?: string } | { _id: string, cityName: string, latitude?: number, longitude?: number } | null}
 */
export function loadLocationPreference() {
  try {
    const raw = localStorage.getItem(LOCATION_PREF_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (p?.mode === 'all') return { mode: 'all' };
    if (p?.mode === 'gps' && typeof p.latitude === 'number' && typeof p.longitude === 'number') {
      const cityName =
        typeof p.cityName === 'string' && p.cityName.trim() ? p.cityName.trim() : undefined;
      return {
        mode: 'gps',
        latitude: p.latitude,
        longitude: p.longitude,
        ...(cityName ? { cityName } : {}),
      };
    }
    if (p?._id) return p;
    return null;
  } catch {
    return null;
  }
}

export function saveLocationPreference(pref) {
  localStorage.setItem(LOCATION_PREF_KEY, JSON.stringify(pref));
}

/** @param {ReturnType<typeof loadLocationPreference>} pref */
export function prefToUserPos(pref) {
  if (!pref || pref.mode === 'all') return null;
  if (pref.mode === 'gps' && pref.latitude != null && pref.longitude != null) {
    return { lat: pref.latitude, lng: pref.longitude };
  }
  if (pref.latitude != null && pref.longitude != null) {
    return { lat: pref.latitude, lng: pref.longitude };
  }
  return null;
}

/** @param {{ address?: { city?: unknown } } | null | undefined} shop */
export function shopCityId(shop) {
  const c = shop?.address?.city;
  if (c == null) return null;
  if (typeof c === 'object' && c !== null && c._id != null) {
    return String(c._id);
  }
  return String(c);
}

/**
 * When filtering by city, only include shops tagged with that city.
 * @param {{ address?: { city?: unknown } } | null | undefined} shop
 * @param {string | null} selectedCityId
 */
export function shopMatchesSelectedCity(shop, selectedCityId) {
  if (!selectedCityId) return true;
  const sid = shopCityId(shop);
  if (!sid) return false;
  return sid === String(selectedCityId);
}
